<template>
  <div class="apply-list">
    <div class="main-title">
      <p>申请列表</p>
    </div>
    <div class="main-body">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="发布状态">
          <el-select
            clearable
            filterable
            v-model="releaseStatus"
            placeholder="请选择"
          >
            <el-option
              v-for="item in pickerAll.status"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择服务">
          <el-select clearable filterable v-model="taskId" placeholder="请选择">
            <el-option
              v-for="item in taskListAll"
              :key="item.id"
              :label="item.label || item.typeDesc + '-' + item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="w100" type="primary" @click="handleQuery"
            >查询</el-button
          >
          <el-button class="w100" type="primary" @click="handleApply"
            >填写申请</el-button
          >
          <el-button class="w100" type="danger" @click="handleAuditReject"
            >审核拒绝</el-button
          >
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable"
        :data="recordList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          property="taskTypeDesc"
          label="服务类型"
        ></el-table-column>
        <el-table-column
          property="branchName"
          label="分支名称"
        ></el-table-column>
        <el-table-column property="comment" label="申请说明"></el-table-column>
        <el-table-column
          property="commitVersion"
          label="提交版本"
        ></el-table-column>
        <el-table-column
          property="moduleName"
          label="模块名称"
        ></el-table-column>
        <el-table-column property="packagingType" label="打包类型">
          <template slot-scope="scope">{{
            getPickerItemDesc(scope.row.packagingType, picker.type)
          }}</template>
        </el-table-column>
        <el-table-column
          property="projectName"
          label="项目名称"
        ></el-table-column>
        <el-table-column
          property="requestTime"
          label="申请时间"
        ></el-table-column>
        <el-table-column property="status" label="状态">
          <template slot-scope="scope">{{
            getPickerItemDesc(scope.row.status, picker.status)
          }}</template>
        </el-table-column>
        <el-table-column property="uploadRepoVersion" label="上传仓库版本">
        </el-table-column>
        <el-table-column
          style="padding: 0 10px;"
          width="200px"
          property="moduleName"
          label="操作"
        >
          <template slot-scope="scope">
            <el-row>
              <el-button
                class="w75"
                v-if="scope.row.status == '10'"
                type="success"
                @click="handleAuditPass(scope.row.id)"
                >审核通过</el-button
              >
              <el-button
                class="w75"
                v-if="scope.row.status == '20'"
                type="success"
                @click="handlePackage(scope.row.id, scope.row.taskType)"
                >{{ scope.row.taskType == "5" ? "上传" : "打包" }}</el-button
              >
              <el-button
                class="w75"
                v-if="scope.row.status == '20'"
                type="warning"
                @click="handleCancelPackage(scope.row.id)"
                >取消打包</el-button
              >
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px">
        <el-pagination
          layout="prev, pager, next"
          :total="totolRows"
          :page-size="pageSize"
          @current-change="handlePageChange"
          background
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="填写发布申请" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="editRecord" label-width="100px">
        <el-form-item label="选择服务">
          <el-select
            clearable
            filterable
            v-model="editRecord.taskId"
            placeholder="请选择服务"
          >
            <el-option
              v-for="item in taskList"
              :key="item.id"
              :label="item.typeDesc + '-' + item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="提交版本号">
          <el-input
            v-model="editRecord.commitVersion"
            placeholder="请输入GIT提交版本号"
          ></el-input>
        </el-form-item>

        <el-form-item label="GIT分支名称">
          <el-input
            v-model="editRecord.branchName"
            placeholder="请输入GIT分支名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="说明">
          <el-input
            v-model="editRecord.comment"
            placeholder="请输入申请说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="w100" @click="dialogVisible = false">取 消</el-button>
        <el-button class="w100" type="primary" @click="handleCommit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "applyList",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      recordList: [],
      taskList: [],
      taskListAll: [],
      editRecord: {},
      dialogVisible: false,
      packagingType: "",
      releaseStatus: "",
      taskId: "",
      picker: {
        type: [],
      },
      pickerAll: {
        type: [],
      },
      totolRows: 0,
      pageNum: 1,
      pageSize: 10,
      selectApplys: [],
      loading: false,
      loadingText: "",
      taskCondition: "",
    };
  },
  mounted() {
    let queryData = this.$route.query;
    if (queryData.releaseStatus && queryData.taskId) {
      this.releaseStatus = queryData.releaseStatus;
      this.taskId = queryData.taskId;
    }
    let self = this;
    Utils.getPicker([
      {
        type: "1",
        name: "status",
      },
      {
        type: "2",
        name: "type",
      },
    ]).then((result) => {
      self.picker = result.picker;
      self.pickerAll = result.pickerAll;
    });
    this.queryRecordList();
    this.getTask();
  },
  methods: {
    handleAuditPass(id) {
      this.$confirm("是否确认审核通过？").then(() => {
        this.operate({ applyId: id }, "/release/auditApprove");
      });
    },

    handlePackage(id, taskType) {
      this.$confirm(
        "是否确认" + (taskType == "5" ? "上传至nexus" : "打包") + "?"
      ).then(() => {
        this.operate({ applyId: id }, "/release/pack");
      });
    },

    handleCancelPackage(id) {
      this.$confirm("是否确认取消打包？").then(() => {
        this.operate({ applyId: id }, "/release/cancelPack");
      });
    },

    operate(param, url) {
      let self = this;
      self.loading = true;
      self.loadingText = "数据正在处理，请稍候...";
      let timeout = setTimeout(() => {
        self.loading = false;
        self.showErrorMessage("请求超时");
      }, 60000);

      this.$http
        .post(url, this.$qs.stringify(param), {
          headers: {
            token: this.token,
          },
        })
        .then(function(response) {
          clearTimeout(timeout);
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.queryRecordList();
        })
        .catch(function(response) {
          clearTimeout(timeout);
          self.loading = false;
        });
    },

    handleQuery() {
      this.pageNum = 1;
      this.queryRecordList();
    },

    handleApply() {
      this.editRecord = {};
      this.dialogVisible = true;
    },

    handleAuditReject() {
      if (this.selectApplys.length == 0) {
        this.$message({
          type: "warning",
          message: "请至少选择一项申请记录",
          center: true,
        });
        return;
      }
      let self = this;
      this.$confirm("是否确认拒绝所选申请记录？").then(() => {
        this.auditReject({ selectedIdList: self.selectApplys.join(",") });
      });
    },

    auditReject(param) {
      let self = this;
      self.loadingText = "数据正在处理，请稍候...";
      self.loading = true;
      this.$http
        .post("/release/auditReject", this.$qs.stringify(param), {
          headers: {
            token: this.token,
          },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleCommit() {
      this.apply(this.editRecord);
    },

    getPickerItemDesc(value, picker) {
      let index = picker.findIndex((element) => element.value == value);
      return index > -1 ? picker[index].label : "";
    },

    apply(param) {
      let self = this;
      self.loadingText = "数据正在处理，请稍候...";
      self.loading = true;
      this.$http
        .post("/release/apply", this.$qs.stringify(param), {
          headers: {
            token: this.token,
          },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.dialogVisible = false;
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleSelectionChange(val) {
      let selectApplys = [];
      let self = this;
      val.forEach((element) => {
        if (element.status == 10) {
          selectApplys.push(element.id);
        } else {
          self.toggleRowSelection(element, false);
        }
      });
      this.selectApplys = selectApplys;
    },

    toggleRowSelection(row, selected) {
      this.$refs.multipleTable.toggleRowSelection(row, selected);
    },

    handlePageChange(val) {
      this.pageNum = val;
      this.queryRecordList();
    },

    queryRecordList() {
      let self = this;
      let param = {
        packagingType: this.packagingType,
        taskId: this.taskId,
        status: this.releaseStatus,
        beginIndex: parseInt((this.pageNum - 1) * this.pageSize),
        pageSize: this.pageSize,
      };
      self.loadingText = "数据正在处理，请稍候...";
      self.loading = true;
      this.$http
        .get("/release/applyList?" + this.$qs.stringify(param), {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.recordList = res.ldata;
          self.totolRows = parseInt(res.mdata.totalCount);
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    getTask() {
      let self = this;
      self.loadingText = "数据正在处理，请稍候...";
      self.loading = true;
      this.$http
        .get(
          "/admin/release/task/list?" +
            this.$qs.stringify({
              condition: this.taskCondition,
            }),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.taskList = res.ldata;
          let taskList = JSON.parse(JSON.stringify(res.ldata));
          taskList.unshift({
            id: "",
            label: "全部",
          });
          self.taskListAll = taskList;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/applyList.vue